import { HandballGameLogTypes } from '../models/handball-game-log';
import { Locales } from './locales';

export const HandballGameLogTypeLocalization = {
  [Locales.ru]: {
    [HandballGameLogTypes.enter_game]: 'Выход на поле',
    [HandballGameLogTypes.exit_game]: 'Ушел с поля',
    [HandballGameLogTypes.shot_miss]: 'Бросок мимо',
    [HandballGameLogTypes.shot_on_goal]: 'Бросок в створ',
    [HandballGameLogTypes.shot_blocked]: 'Заблокированный бросок',
    [HandballGameLogTypes.goal]: 'Гол',
    [HandballGameLogTypes.assist]: 'Передача',
    [HandballGameLogTypes.penalty_miss]: '7м промах',
    [HandballGameLogTypes.penalty_shot_on_goal]: '7м в створ',
    [HandballGameLogTypes.penalty_goal]: '7м гол',
    [HandballGameLogTypes.save]: 'Сэйв',
    [HandballGameLogTypes.penalty_save]: 'Сэйв 7м',
    [HandballGameLogTypes.foul]: 'Фол',
    [HandballGameLogTypes.yellow_card]: 'Желлтая карточка',
    [HandballGameLogTypes.red_card]: 'Красная карточка',
    [HandballGameLogTypes.two_minute_foul]: '2х минутный штраф',
    [HandballGameLogTypes.turnover]: 'Потеря',
    [HandballGameLogTypes.steal]: 'Перехват',
    [HandballGameLogTypes.block_shot]: 'Блок броска',
    [HandballGameLogTypes.timeout]: 'Таймаут',
  },
  [Locales.en]: {
    [HandballGameLogTypes.enter_game]: 'Entering the court',
    [HandballGameLogTypes.exit_game]: 'Exit the court',
    [HandballGameLogTypes.shot_miss]: 'Missing shot',
    [HandballGameLogTypes.shot_on_goal]: 'Shot on goal',
    [HandballGameLogTypes.shot_blocked]: 'Blocking shot',
    [HandballGameLogTypes.goal]: 'Goal',
    [HandballGameLogTypes.assist]: 'Assist',
    [HandballGameLogTypes.penalty_miss]: 'Penalty miss',
    [HandballGameLogTypes.penalty_shot_on_goal]: 'Penalty on goal',
    [HandballGameLogTypes.penalty_goal]: 'Penalty goal',
    [HandballGameLogTypes.save]: 'Save',
    [HandballGameLogTypes.penalty_save]: 'Penalty save',
    [HandballGameLogTypes.foul]: 'Foul',
    [HandballGameLogTypes.yellow_card]: 'Yellow card',
    [HandballGameLogTypes.red_card]: 'Red card',
    [HandballGameLogTypes.two_minute_foul]: '2-minute penalty',
    [HandballGameLogTypes.turnover]: 'Turnover',
    [HandballGameLogTypes.steal]: 'Steal',
    [HandballGameLogTypes.block_shot]: 'Block shot',
    [HandballGameLogTypes.timeout]: 'Timeout',
  }
};
